import { withHandlers, compose, withProps, lifecycle, branch, renderNothing, withStateHandlers } from 'recompose'
import { connect } from 'react-redux'
import { addSavedItemToCart, removeSaveForLaterItemAction, handleProductClickAction } from './actions'
import SaveForLaterItem from './SaveForLaterItem'
import { getCurrentStorePhoneNumber } from 'selectors/getCurrentStore'
import { getFavoriteSkus } from 'components/MyFavorites/selectors'

const mapStateToProps = state => ({
  storePhoneNumber: getCurrentStorePhoneNumber(state),
  favoriteSkus: getFavoriteSkus(state)
})

const withClickHandlers = withHandlers({
  handleRemoveItem: ({ setItemState }) => (e) => {
    setItemState('deleteRequested')
  },
  handleAddToQuote: ({ setItemState }) => (e) => {
    setItemState('addToQuoteRequested')
  },
  handleProductClick: ({ product, handleProductClickAction, favoriteSkus }) => e => {
    handleProductClickAction({ product, favoriteSkus })
  }
})

const withStates = withStateHandlers(
  ({ product: { quantity }}) => ({
    tireQuantity: quantity,
    itemState: null
  }),
  {
    handleQuantityChange: () => value => ({ tireQuantity: value }),
    setItemState: () => value => ({ itemState: value }) // deleteRequested, addToQuoteRequested, inProgress
  }
)

const withStoreInformation = withProps(({ product: { listPrice }}) => ({
  isShowCallStoreForPrice: Number(listPrice) === 0
}))

const withLifecycle = lifecycle({
  componentDidUpdate({ itemState: prevItemState, product: { quantity: prevQuantity }}) {
    const {
      handleQuantityChange,
      itemState,
      setItemState,
      removeSaveForLaterItemAction,
      handleTAOSDateTimeUpdate,
      addSavedItemToCart,
      tireQuantity,
      product: { skuId, quantity },
      product,
      favoriteSkus
    } = this.props

    if (quantity !== prevQuantity) {
      handleQuantityChange(quantity)
    }

    if (!prevItemState && itemState) {
      itemState === 'deleteRequested' && removeSaveForLaterItemAction(skuId)
      itemState === 'addToQuoteRequested' && addSavedItemToCart(
        skuId,
        tireQuantity,
        handleTAOSDateTimeUpdate,
        product,
        favoriteSkus
      )
      setTimeout(() => setItemState('inProgress'), 200)
    }
  }
})

const withRenderNothing = branch(
  ({ itemState }) => itemState === 'inProgress',
  renderNothing
)

export default compose(
  connect(mapStateToProps, { addSavedItemToCart, removeSaveForLaterItemAction, handleProductClickAction }),
  withStates,
  withClickHandlers,
  withStoreInformation,
  withLifecycle,
  withRenderNothing
)(SaveForLaterItem)
